<template>
    <div class="modal fade" id="shareModal" ref="shareModal" tabindex="-1" aria-labelledby="shareModal"
        aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered max-w-full tablet:!max-w-[400px] tablet:!absolute tablet:!right-4 !top-0 mobile:!mx-2.5 tablet:!m-0 h-full ">
            <div class="modal-content font-roboto">
                <div class="!p-[10px] !pb-[1rem] largeDesktop:!pb-[2rem]">
                    <div class="relative">
                        <button type="button" @click="hideshareModal()"
                            class="absolute top-3 right-3 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close">
                            <img src="../../assets/images/white-cross-icon.svg" alt="Cross Icon"
                                class="min-w-[30px] min-h-[30px] max-w-[30px] max-h-[30px] object-contain">
                        </button>
                        <div
                            class="rounded-lg overflow-hidden h-[80px] bg-customBlue-100 flex flex-col justify-center gap-1 p-3 w-full">
                            <h4 class="text-xl font-semibold font-poppins m-0 text-white">
                                Share
                            </h4>
                        </div>
                    </div>
                    <div class="relative">
                        <div class="pt-3 2xl:pt-5">
                            <sharePlanForm ref="sharePlanFormRefs" @sendBtnClick="sendBtnClick" :reset="resetForm" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Modal } from "bootstrap";
import { useToast } from "vue-toastification";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
import sharePlanForm from "../../components/partialComponent/sharePlanForm.vue";
const toast = useToast();
export default {
    components: {
        sharePlanForm
    },
    data() {
        return {
            resetForm: null
        };
    },
    computed: {
        ...mapGetters([
            "shareProtectionPlans",
            "sendProtectionPlanURLResponse"
        ]),
    },
    watch: {
        shareProtectionPlans: function (data) {
                this.resetForm = new Date()
                const modalEl = this.$refs.shareModal;
                const modal = new Modal(modalEl);
                disableScroll();
                modal.show();

                setTimeout(() => {
                    this.$refs.sharePlanFormRefs.updateUrl(this.shareProtectionPlans.url)
                }, 100);
        },

        sendProtectionPlanURLResponse: function (data) {
            this.hideshareModal()
            toast.success("We’ve sent the Protection Plan link to the consumer.");
        },
    },
    methods: {
        ...mapActions([
            "getShareProtectionPlans",
            "sendShareProtectionPlanURL"
        ]),
        openModal() {
            this.getShareProtectionPlans({})
        },
        hideshareModal() {
            const modalEl = this.$refs.shareModal;
            if (modalEl) {
                const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
                enableScroll();
                modal.hide();
            }
        },

        sendBtnClick(payload) {
            payload['url_identifier'] = this.shareProtectionPlans.url_identifier
            this.sendShareProtectionPlanURL(payload)
        }
    }
}
</script>